import { OrdStatusEnum, QuoteStatusEnum } from '../../../types/types';
import { includesEnumValue } from '../../../utils/enumlikeHandlers';
import { OrderStatusText } from '../../Status/types';

export const Filters = {
  NewRequest: 'Request Sent',
  Review: 'Review',
  Open: 'Open',
  OpenLoan: 'Open',
  Filled: 'Filled',
  Canceled: 'Canceled',
  Rejected: 'Rejected',
} as const;
export type Filters = (typeof Filters)[keyof typeof Filters];

export const QUOTE_STATUS_MAPPING = {
  'All Open': [
    QuoteStatusEnum.Open,
    QuoteStatusEnum.PendingNew,
    QuoteStatusEnum.PendingFill,
    QuoteStatusEnum.PendingCancel,
  ],
  'All Filled': [QuoteStatusEnum.Filled, QuoteStatusEnum.PendingFix],
  'All Canceled': [QuoteStatusEnum.Canceled],
  'All Rejected': [QuoteStatusEnum.Rejected],
};

export const ORD_STATUS_MAPPING = {
  'All Open': [
    OrdStatusEnum.New,
    OrdStatusEnum.PendingNew,
    OrdStatusEnum.PendingReplace,
    OrdStatusEnum.PendingCancel,
    OrdStatusEnum.PartiallyFilled,
  ],
  'All Filled': [OrdStatusEnum.Filled, OrdStatusEnum.PendingFix, OrdStatusEnum.DoneForDay],
  'All Canceled': [OrdStatusEnum.Canceled],
  'All Rejected': [OrdStatusEnum.Rejected],
};

const DONE_ORDER_STATUSES = [
  OrdStatusEnum.Canceled,
  OrdStatusEnum.Filled,
  OrdStatusEnum.Rejected,
  OrdStatusEnum.DoneForDay,
] as const;

const incompleteOrderStatuses = Object.values(OrdStatusEnum).filter(
  status => !includesEnumValue(DONE_ORDER_STATUSES, status)
) satisfies Exclude<OrdStatusEnum, (typeof DONE_ORDER_STATUSES)[number]>[];

export const ORD_TEXT_TO_STATUS_MAPPING: Record<OrderStatusText, OrdStatusEnum[]> = {
  [OrderStatusText.Open]: [
    OrdStatusEnum.New,
    OrdStatusEnum.PendingNew,
    OrdStatusEnum.PartiallyFilled,
    OrdStatusEnum.Holding,
    OrdStatusEnum.Replaced,
  ],
  [OrderStatusText.Filled]: [OrdStatusEnum.Filled, OrdStatusEnum.DoneForDay],
  [OrderStatusText.Canceled]: [OrdStatusEnum.Canceled, OrdStatusEnum.DoneForDay],
  [OrderStatusText.FilledAndCanceled]: [OrdStatusEnum.Canceled, OrdStatusEnum.DoneForDay],
  [OrderStatusText.Rejected]: [OrdStatusEnum.Rejected],
  [OrderStatusText.Paused]: incompleteOrderStatuses,
  [OrderStatusText.SystemPaused]: incompleteOrderStatuses,
  [OrderStatusText.Staged]: incompleteOrderStatuses,
  [OrderStatusText.Waiting]: incompleteOrderStatuses,
  [OrderStatusText.PendingCancel]: [OrdStatusEnum.PendingCancel],
  [OrderStatusText.PendingReplace]: [OrdStatusEnum.PendingReplace],
  [OrderStatusText.PendingFix]: [OrdStatusEnum.PendingFix],
  //Special Unknown state only occurs when backend data has null orderStatus
  [OrderStatusText.Unknown]: [null as unknown as OrdStatusEnum],
};
